/** @prettier */
import { addHours, isValid } from 'date-fns';
import { List } from 'immutable';

import { STEP_NAMES } from '../constants';

export const shortenMessages = (errors = new List()) =>
  errors.map(({ field, messages }) => {
    let message = messages[0];

    if (message.indexOf('username or password is incorrect') > -1) {
      message = 'Invalid username or password';
    }

    if (message.indexOf('account is locked') > -1) {
      message = 'Cannot login. Account is locked';
    }

    if (message.indexOf('Password cannot be blank') > -1) {
      message = 'Password cannot be blank';
    }

    if (message.indexOf('Username cannot be blank') > -1) {
      message = 'Username cannot be blank';
    }

    return {
      field,
      messages: [message],
    };
  });

export const formatDateOfBirth = (dateOfBirth = '') => {
  const computedDateOfBirth = dateOfBirth.replace(/-/g, '/').split('/').reverse().join('/');

  const dateObject = new Date(computedDateOfBirth);

  if (isValid(dateObject)) {
    const editedDateObject = new Date(
      dateObject.getTime() - dateObject.getTimezoneOffset() * 60000
    );

    return new Date(addHours(editedDateObject, 12)).toISOString();
  }

  return 'Invalid Date';
};

export const getErrorsStep = (errors, fields) =>
  errors.reduce((update, { field: fieldKey }) => {
    if (fields[fieldKey]) {
      if (fields[fieldKey].section === STEP_NAMES[0] && update !== STEP_NAMES[0]) {
        return 0;
      }

      if (fields[fieldKey].section === STEP_NAMES[1] && update !== STEP_NAMES[1]) {
        return 1;
      }
    }

    return 2;
  }, '');

export const updateSignUpTrialsFlag = () => {
  try {
    const currentSignUpTrials = parseInt(localStorage.getItem('mb-user-reg-trials'), 10) || 0;
    localStorage.setItem('mb-user-reg-trials', currentSignUpTrials + 1);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Cannot access to localStorage');
  }
};

export const getSignUpFlag = (key) => {
  try {
    return parseInt(localStorage.getItem(key), 10) || 0;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Cannot access to localStorage');
  }

  return 0;
};
